const s = "slider_nuURE", e = {
  slider: s
};
export {
  e as default,
  s as slider
};
//# sourceMappingURL=slider.module.scss.js.map
